import type { UploadFile } from 'antd';

export enum SizeUnit {
  b = 'b',
  kb = 'kb',
  mb = 'mb',
  gb = 'gb',
}
export type ProListType = {
  data: any[];
  total?: number;
  [key: string]: any;
};
export type YsListType = {
  list: any[];
  total?: number;
  [key: string]: any;
};

export type YsFileResult =
  | {
      file?: string;
      [key: string]: any;
    }
  | string;

export interface YsUploadFile<T> extends UploadFile<T> {
  wholeUrl?: string;
}

export interface CodecInfoTracks {
  // 编码
  codec: string;
  // 时间粒度的个数
  duration: number;
  // 时间的粒度，1000表示1000个单位为1s
  timescale: number;
  // 类型，如 video | audio
  type: string;
  // 名称
  name: string;
  // 大小
  size: number;
  // 比特率
  bitrate: number;
  // 创建时间
  created: Date;
  [key: string]: any;
}

export interface CodecInfo {
  // 实际时长，单位s，即 duration/timescale
  durationActual: number;
  // 时间粒度的个数
  duration: number;
  // 时间的粒度，1000表示1000个单位为1s
  timescale: number;
  // 大小, 单位b
  size: number;
  // 元类型
  mime: string;
  // 轨道
  tracks: CodecInfoTracks[];
  [key: string]: any;
}
